<template>
  <div>
    <w-wysiwyg :model="$schema.interpretation" :config="wyswigConfig" />

    <w-wysiwyg :model="$schema.description" :config="wyswigConfig" />

    <div class="mt-4">
      <button class="btn btn-primary float-left" @click="previousStep">
        Wstecz
      </button>

      <button class="btn btn-primary float-right" @click="submit">
        Zakończ
      </button>
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import { wizardStepMixin } from '@/mixins/wizardStep';
import schema from '@/schemas/procedure.schema';

// @vuese
// Formularz dokumentu ogólnego
// @group ActionData
export default {
  components,
  schema,
  mixins: [wizardStepMixin('procedure')],
  data() {
    return {
      wyswigConfig: { allowedContent: true, height: 450 }
    };
  },
  methods: {
    // @vuese
    // Powrót na listę procedur po zapisaniu
    afterSave() {
      this.$router.push({ name: 'procedureList' });
    }
  }
};
</script>
